import { WidgetRoot } from './components/WidgetRoot';
import { withSlotsPlaceholders } from '@wix/widget-plugins-ooi';

export default withSlotsPlaceholders(WidgetRoot);
